import { render, staticRenderFns } from "./tizhi.vue?vue&type=template&id=f4897b3e&scoped=true"
import script from "./tizhi.vue?vue&type=script&lang=ts"
export * from "./tizhi.vue?vue&type=script&lang=ts"
import style0 from "./tizhi.vue?vue&type=style&index=0&id=f4897b3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4897b3e",
  null
  
)

export default component.exports